"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

var _PostStatus = _interopRequireDefault(require("../../../../../common/components/PostStatus"));

var _utils = require("../../../../../common/utils");

require("../styles/_post-list-item.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var getDate = function getDate(date) {
  return (0, _moment.default)(date).format('YYYY/MM/DD [at] hh:mm A');
};

var getPublishActionLabel = function getPublishActionLabel(postStatus) {
  return postStatus === 'DRAFT' ? 'PUBLISH' : 'UNPUBLISH';
};

var getFeaturedActionLabel = function getFeaturedActionLabel(isFeatured) {
  return "".concat(!isFeatured ? 'SET' : 'REMOVE', " FEATURED");
};

function getActionOptions(_ref) {
  var post = _ref.post,
      showDeleteConfirmationModal = _ref.showDeleteConfirmationModal,
      showFeaturedConfirmationModal = _ref.showFeaturedConfirmationModal,
      showEditPostModal = _ref.showEditPostModal,
      orgPermissions = _ref.orgPermissions;
  var postIdToEdit = post.inspirationId;

  var deleteConfirmationModalHandler = function deleteConfirmationModalHandler() {
    return showDeleteConfirmationModal({
      postIdToEdit: postIdToEdit
    });
  };

  var showEditPostModalHandler = function showEditPostModalHandler() {
    return showEditPostModal({
      postIdToEdit: postIdToEdit
    });
  };

  var showSetFeaturedHandler = function showSetFeaturedHandler() {
    return showFeaturedConfirmationModal({
      postIdToEdit: postIdToEdit,
      isFeatured: Boolean(post.featuredAt)
    });
  };

  var actionOptions = [{
    action: showEditPostModalHandler,
    label: 'EDIT POST',
    requiredPermission: 'UPDATE'
  }, {
    action: showSetFeaturedHandler,
    label: getFeaturedActionLabel(Boolean(post.featuredAt)),
    requiredPermission: 'FEATURE_INSPIRATION_POST'
  }, {
    action: deleteConfirmationModalHandler,
    label: 'DELETE',
    isRed: true,
    requiredPermission: 'DELETE'
  }];
  var postPermissions = post.permissions || [];
  var options = actionOptions.filter(function (_ref2) {
    var requiredPermission = _ref2.requiredPermission;
    return !requiredPermission || (0, _commonReact.hasPermission)(requiredPermission, [].concat(_toConsumableArray(postPermissions), _toConsumableArray(orgPermissions)));
  });
  return options;
}

function PostListItem(_ref3) {
  var showPublishConfirmationModal = _ref3.showPublishConfirmationModal,
      showDeleteConfirmationModal = _ref3.showDeleteConfirmationModal,
      showFeaturedConfirmationModal = _ref3.showFeaturedConfirmationModal,
      showEditPostModal = _ref3.showEditPostModal,
      orgPermissions = _ref3.orgPermissions;
  return function (post) {
    var inspirationId = post.inspirationId,
        status = post.status,
        title = post.title,
        description = post.description,
        updatedByUser = post.updatedByUser,
        updatedAt = post.updatedAt,
        featuredAt = post.featuredAt,
        thumbnailUrl = post.thumbnailUrl,
        assetId = post.assetId;

    var showPublishModalHandler = function showPublishModalHandler() {
      return showPublishConfirmationModal({
        postIdToEdit: post.inspirationId,
        isPublished: status === 'PUBLISHED'
      });
    };

    return _react.default.createElement(_uiKit.List.ListItem, {
      key: inspirationId,
      className: "manage-manage-post-list-item",
      hideImage: true
    }, assetId || thumbnailUrl ? _react.default.createElement(_commonReact.AssetPreview, _extends({}, (0, _utils.buildAssetPreviewProps)({
      assetId: assetId,
      thumbnailUrl: thumbnailUrl
    }), {
      width: "100px",
      height: "100px",
      borderRadius: 6,
      hideFileTypeIcon: true
    })) : _react.default.createElement(_uiKit.Image, {
      defaultImageIcon: "guide",
      height: "100px",
      width: "100px",
      borderRadius: 6,
      defaultIconColour: "russian"
    }), _react.default.createElement(_PostStatus.default, {
      status: status
    }), _react.default.createElement("div", {
      className: "manage-post-list-item__details"
    }, _react.default.createElement("div", {
      className: "manage-post-list-item__details__right-content"
    }, _react.default.createElement("p", {
      className: "manage-post-list-item__details__title"
    }, _react.default.createElement("strong", null, title)), Boolean(featuredAt) && _react.default.createElement(_uiKit.Icon, {
      className: "manage-post-list-item__details__featured",
      name: "favourite",
      color: "dandelion",
      size: 21
    }), _react.default.createElement("p", {
      className: "manage-post-list-item__details__sub-title"
    }, description))), updatedByUser && _react.default.createElement(_uiKit.List.ListItem.UserDetails, {
      userName: (0, _getUserFullName.default)(updatedByUser),
      profileImage: updatedByUser.imageUrl
    }, _react.default.createElement("small", {
      className: "manage-post-list-item__user-role"
    }, updatedByUser.jobTitle)), _react.default.createElement("div", {
      className: "manage-post-list-item__date"
    }, _react.default.createElement("p", null, getDate(updatedAt)), _react.default.createElement("small", {
      className: "manage-post-list-item__user-role"
    }, "Last Updated")), (0, _commonReact.hasPermission)('UPDATE', post.permissions) ? _react.default.createElement(_uiKit.Button, {
      small: true,
      type: status === 'DRAFT' ? void 0 : 'SECONDARY',
      onClick: showPublishModalHandler,
      className: "manage-post-list-item__publish-btn"
    }, getPublishActionLabel(status)) : null, _react.default.createElement(_uiKit.ActionPopup, {
      popupBtn: _react.default.createElement(_uiKit.Icon, {
        name: "options",
        color: "regent"
      }),
      options: getActionOptions({
        post: post,
        showPublishConfirmationModal: showPublishConfirmationModal,
        showDeleteConfirmationModal: showDeleteConfirmationModal,
        showFeaturedConfirmationModal: showFeaturedConfirmationModal,
        showEditPostModal: showEditPostModal,
        orgPermissions: orgPermissions
      })
    }));
  };
}

var _default = PostListItem;
exports.default = _default;